import { configureStore } from '@reduxjs/toolkit';
import clientsReducer from './clientsSlice';
import { deviceReducer, displayLayoutReducer, scheduledAnnouncementsReducer, clusterReducer, adsReducer, adPlaylistReducer, flightRemovalOffsetReducer, announcementsReducer } from '@industronics/dcmm';

export const store = configureStore({
  reducer: {
    clients: clientsReducer,
    devices: deviceReducer,
    clusters: clusterReducer,
    ads: adsReducer,
    adPlaylist: adPlaylistReducer,
    flightRemovalOffsets: flightRemovalOffsetReducer,
    announcements: announcementsReducer,
    scheduledAnnouncements: scheduledAnnouncementsReducer,
    displayLayouts: displayLayoutReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
